import React, { useEffect, useState } from 'react'
import jwt_decode from "jwt-decode";
import { DOWNLOAD_REQUEST_DOC, GET_DOC_LIST, GET_ENROLLMENT_PROCESS_BY_ID } from '../APIS';
import { RSAencryptData } from '../Documents/RSAEnc';
import { FormBiodata, FormContacts, FormParents, StdHeaders } from './components';
import { Accordion, Button, useAccordionToggle, Card } from "react-bootstrap";
import LoadingBtn from '../../Widgets/LoadingBtn';
import { AlertNotif } from '../../../Library/AlertNotif';
import { Error404 } from '../../../Library/LoaderPage';
import { Documents } from '../Documents';

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export function Profile(props) {
  const student = props?.student || "";

  const registered_id = student?.regstudent?.registered_id || "";
  const doc_req_name = `doc_list_${student?.candidate_id}`;
  const local_name_pp = `blob_pp_${student.candidate_id}`;
  const doc_type = "strg.doc.type.pasfoto";
  const status_file = "strg.file.status.uploaded";

  const [profilePic, setProfilePic] = useState("");

  const OWNER_DOC = async () => {
    setProfilePic("");
    const param = { owner: registered_id };
    const objData = JSON.stringify(param);
    const rsaEnc = RSAencryptData(objData);
    const formData = new FormData();
    formData.append("data", rsaEnc);
    const results = await GET_DOC_LIST(formData);
    if (results.result === "success") {
      if (results.data.data && Object.values(results.data.data).length > 0) {
        const get_active_doc = results.data.data.filter(
          (item) => item.status === status_file
        );
        const find_pp = get_active_doc.find((item) => item.doc_type === doc_type && item.verify === 1);
        setProfilePic(find_pp);
        localStorage.setItem(doc_req_name, JSON.stringify(get_active_doc));
      } else {
        localStorage.setItem(doc_req_name, "");
      }
    } else {
      localStorage.setItem(doc_req_name, "");
    }
  };

  useEffect(() => {
    const loadData2 = async () => {
      const storedData = localStorage.getItem(doc_req_name);
      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          console.log(data);
        } catch (error) {
          console.error("Error parsing stored data:", error);
          await OWNER_DOC();
        }
      } else {
        await OWNER_DOC();
      }
    };

    if (registered_id && registered_id !== "") {
      loadData2();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [registered_id]);

  useEffect(async () => {
    if (profilePic && Object.values(profilePic).length > 0) {
      const file_id = profilePic?.file_id || "";
      if (file_id) {
        await RenderPP(file_id);
      }
    }
  }, [profilePic])

  const RenderPP = async (file_id) => {
    const objData = JSON.stringify({
      file_id: file_id,
      user: AuthDecode?.identity?.email || "",
    });
    const rsaEnc = RSAencryptData(objData);
    const formData = new FormData();
    formData.append("data", rsaEnc);
    formData.append("file", []);
    const download = await DOWNLOAD_REQUEST_DOC(formData);
    if (download.status === 200) {
      if (download.data.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = function () {
          const base64data = reader.result;
          localStorage.setItem(local_name_pp, base64data);
        };
        reader.readAsDataURL(download.data);
      } else {
        localStorage.setItem(local_name_pp, '');
      }
    } else {
      localStorage.setItem(local_name_pp, '');
    }
  };

  const [candidats, setCandidats] = useState({ loading: false, data: [], message: "" });

  const ReloadCandidates = async () => {
    setCandidats({ loading: true, data: [], message: "" });
    const results = await GET_ENROLLMENT_PROCESS_BY_ID({ enroll_id: student?.id });
    setCandidats(results);
  }

  useEffect(() => {
    ReloadCandidates();
  }, []);

  return (
    <div id="my-profiles" className="container-fluid">
      <StdHeaders student={student} />

      <div className="bg-white rounded">
        {candidats.loading ? <LoadingBtn /> :
          candidats.message ? <AlertNotif message={candidats.message} /> :
            candidats.data && Object.values(candidats.data).length > 0 ? (
              <Accordion defaultActiveKey="0">
                <Card>
                  <Card.Header>
                    <CustomToggle eventKey="0">
                      <div className="d-flex justify-content-between align-items-center">
                        <h2 className="mb-0 text-left">1. Personal Information</h2>
                      </div>
                    </CustomToggle>
                  </Card.Header>
                </Card>
                <Accordion.Collapse eventKey="0">
                  <FormBiodata data={candidats.data?.regstudent} />
                </Accordion.Collapse>


                <Card>
                  <Card.Header>
                    <CustomToggle eventKey="1">
                      <div className="d-flex justify-content-between align-items-center">
                        <h2 className="mb-0 text-left">2. Contact Addresses</h2>
                      </div>
                    </CustomToggle>
                  </Card.Header>
                </Card>
                <Accordion.Collapse eventKey="1">
                  <FormContacts data={candidats.data?.regstudent} />
                </Accordion.Collapse>

                <Card>
                  <Card.Header>
                    <CustomToggle eventKey="2">
                      <div className="d-flex justify-content-between align-items-center">
                        <h2 className="mb-0 text-left">3. Parent Information</h2>
                      </div>
                    </CustomToggle>
                  </Card.Header>
                </Card>
                <Accordion.Collapse eventKey="2">
                  <FormParents data={candidats.data?.regstudent} />
                </Accordion.Collapse>

                <Card>
                  <Card.Header>
                    <CustomToggle eventKey="3">
                      <div className="d-flex justify-content-between align-items-center">
                        <h2 className="mb-0 text-left">4. Document Requirements</h2>
                        {student.doc_status && (
                          <div className={`badge badge-${student.doc_status === 1 ? 'primary' : 'warning'} pb-2 px-5`}>
                            <span className="mr-2 font-weight-bold">
                              {student.doc_status === 1 ? "Completed" : "Uncompleted"}
                            </span>
                          </div>
                        )}
                      </div>
                    </CustomToggle>
                  </Card.Header>
                </Card>
                <Accordion.Collapse eventKey="3">
                  <Documents student={candidats.data?.regstudent} />
                </Accordion.Collapse>

              </Accordion>
            ) : <Error404 />}
      </div>
    </div>
  )
}


const CustomToggle = ({ children, eventKey }) => {
  const decoratedOnClick = useAccordionToggle(eventKey);

  return (
    <Button
      type="button"
      onClick={decoratedOnClick}
      className="btn-light w-100"
    >
      {children}
    </Button>
  );
};